import React from 'react';
import {Area, AreaChart, Label, Legend, Tooltip, XAxis, YAxis} from "recharts";

import "./ArtificialInflationGraph.css"
import {numberWithCommas, dollarFormat} from "../../../util";

const CustomTooltip = (props) => {
	const payloadItems = [];
	for (let payloadIndex in props.payload) {
		const payload = props.payload[payloadIndex];

		let value = payload.value;
		if (payload.dataKey === 'volume') {
			value = value.toFixed(2);
		}
		if (payload.dataKey === 'closingPriceLessInflation') {
			value = '$' + value;
		}
		if (payload.dataKey === 'closingPrice') {
			value = '$' + value;
		}

		payloadItems.push(
			<li key={payload.name} className="recharts-tooltip-item"
				style={{display: 'block', paddingTop: '4px', paddingBottom: '4px'}}>
				<span className="recharts-tooltip-item-name">{payload.name}</span>
				<span className="recharts-tooltip-item-separator"> : </span>
				<span
					className="recharts-tooltip-item-value">{payload.name === 'Volume' ? numberWithCommas(value) : value}</span>
			</li>
		);
	}


	return (
		<div style={{
			margin: '0px',
			padding: '5px',
			backgroundColor: 'black',
			color: 'white',
			fontFamily: 'GothamLight',
			lineHeight: 1.2
		}}>
			<p className={"recharts-tooltip-label"}>{new Date(props.label).toLocaleDateString()}</p>
			<ul style={{padding: '0px', margin: '0px'}}>
				{payloadItems}
			</ul>
		</div>
	);
};

const ArtificialInflationGraphComponent = (props) => (
	// <ResponsiveContainer width={1200} height={400}>
		<AreaChart data={props.graphData}
		width={1200} height={400}
				   margin={{top: 15, right: 30, left: 20, bottom: 5}}>
			<XAxis dataKey='t'
				   stroke="white"
				   type='number'
				   domain={[
					   Math.min.apply(Math, props.graphData.map(tick => tick.t)),
					   Math.max.apply(Math, props.graphData.map(tick => tick.t))
				   ]}
				   tickFormatter={x => {
					   return new Date(x).toLocaleDateString();
				   }}
				   ticks={props.tickDates}
				   angle={-45}
				   textAnchor="end"
				   height={90}>
				<Label value={'Date'} dy={22}/>
			</XAxis>
			<YAxis yAxisId="left"
				   name="Price"
				   stroke="white"
				   tickFormatter={dollarFormat}>
				<Label value='Stock Closing Price' angle={-90} position="insideLeft"/>
			</YAxis>
			<YAxis yAxisId="right"
				   name="Volume"
				   orientation="right"
				   tickFormatter={numberWithCommas}
				   stroke="white">
				<Label value="Vol (000s)" angle={-90} position="right"/>
			</YAxis>

			<Tooltip
				content={<CustomTooltip/>}
			/>
			<Legend iconType='square'/>
			{props.caseRuleTypeId != null && props.caseRuleTypeId === 3 ?
				""
				:
				<Area yAxisId="left" type='monotone' dataKey='closingPrice' stackId="1"
				 	stroke='#C00000' name={props.isDandO === "true"?"Actual Closing Stock Price" : "Alleged Inflated Stock Price"} fill='#C00000' isAnimationActive={false}/>
			}
			<Area yAxisId="left" type='monotone' dataKey='closingPriceLessInflation' stackId="3"
				  stroke='#22aef0' name={props.isDandO === "true"?"Potential \"But-For\" Stock Price" : "Stock Price"} fill='#22aef0' isAnimationActive={false}/>
			<Area yAxisId="right" type='monotone' dataKey='volume' stackId="2" name='Volume'
				  stroke='#f0ec00' fill='#f0ec00' isAnimationActive={false}/>

		</AreaChart>
	// </ResponsiveContainer>
);


export default ArtificialInflationGraphComponent;



// WEBPACK FOOTER //
// ./src/common/components/ArtificialInflationGraph/ArtificialInflationGraphComponent.js